// @flow

export const small = "2px";
export const medium = "4px";
export const large = "8px";
